import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { TryItNowPage } from './pages/TryItNowPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/try-it" element={<TryItNowPage data-id="element-5" />} data-id="element-4" />
      </Routes>
    </Router>;
}